module.exports = __webpack_public_path__ + "static/en-09ffd6016e5243ef8067c63c4e7aff97.png";